import { useEffect, useEffectEvent, useRef, useState } from 'react';

export function useInitState(options?: { timeout?: number }) {
  const { timeout = 1000 } = options ?? {};
  const timeoutRef = useRef(timeout);
  const [isInitialRender, setIsInitialRender] = useState(true);

  const initApp = useEffectEvent(() => {
    setIsInitialRender(false);
  });

  useEffect(() => {
    let idleCallback: number;
    if (isInitialRender) {
      idleCallback = requestIdleCallback(initApp, {
        timeout: timeoutRef.current,
      });
    }

    return () => {
      if (idleCallback !== undefined && idleCallback !== null) {
        cancelIdleCallback(idleCallback);
      }
    };
  }, [isInitialRender]);

  return { isInitialRender };
}
